"use client"
import React from 'react'
import ImpactCard from '../medhavi-foundation/Impactcard'
import {
    Users,
    Layers,
    Handshake,
    MapPin,
    Award,
    TrendingUp,
    Briefcase,
    GraduationCap,
    Building2,
} from "lucide-react";

const Impactpage = () => {
    const impactCards = [
        {
            icon: Users,
            value: "5,50,000+",
            label: "Candidates Trained",
        },
        {
            icon: Handshake,
            value: "250+",
            label: "Medhavi Skill Academies & Pradhan Mantri Kaushal Kendras",
        },
        {
            icon: MapPin,
            value: "70%+",
            label:"Candidates from Tribal, Aspirational, LWE, Hilly, Mining & Backward Areas",
        },
        {
            icon: Award,
            value: "105",
            label: "Specially Abled Youth Trained & Placed",
        },
        {
            icon: TrendingUp,
            value: "15,000+",
            label:
                "Deployed in the Industry Under Work Integrated Skill-based Higher Education (WISE)",
        },
        {
            icon: Briefcase,
            value: "1,20,000+",
            label: "Candidates Trained in the North-Eastern States",
        },
        {
            icon: GraduationCap,
            value: "50,000+",
            label: "Apprentices Enabled",
        },
        {
            icon: Building2,
            value: "350+",
            label: "Industry, CSR & Government Partners",
        },
    ];
    return (
        <div className="mt-10 pb-14 grid xl:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-6 xl:gap-8 w-full">
            {impactCards.map((item, index) => (
                <ImpactCard
                    key={index}
                    icon={item.icon}
                    value={item.value}
                    label={item.label}
                    delay={index * 0.08}
                />
            ))}
        </div>
    )
}

export default Impactpage